import CrudModule from "@/components/CrudModule";
import InstaBrainIntegrationOverview from "@/components/InstaBrainIntegrationOverview";
import { MODULES } from "@/config/modules";

export default function Quotes() {
  return <>
    <InstaBrainIntegrationOverview />
    <CrudModule module={MODULES.quotes} subtitle="Track carriers, products, applications and carrier decisions. InstaBrain placement is surfaced above; verified application/policy sync will flow into this same workspace." />
  </>;
}
